<template>
  <div class="report-section">
    <h3 class="line-item-title">
      3. Contributions and receipts
    </h3>
    <div v-if="arrayHasItems(report.user_data.contribution_corrections)">
      <v-simple-table dense>
        <thead>
        <tr>
          <th class="dateColumn">
            Date Reported
          </th>
          <th>
            Contributor
          </th>
          <th>
            Description
          </th>
          <th class="amountColumn">
            Amount Reported
          </th>
          <th class="amountColumn">
            Corrected Amount
          </th>
          <th class="amountColumn">
            Difference
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in report.user_data.contribution_corrections" :key="index">
          <td>
            {{ formatDate(item.date) }}
          </td>
          <td>
            <ContactInfo :contacts="contacts" :cont-id="item.contact_key"/>
          </td>
          <td>
            {{ item.description }}
          </td>
          <td class="amountColumn">
            {{ formatMoney(item.reported_amount) }}
          </td>
          <td class="amountColumn">
            {{ formatMoney(item.corrected_amount) }}
          </td>
          <td class="amountColumn">
            {{ formatMoney(item.difference) }}
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div v-else class="noReport">
      No Contributions and receipts reported this period
    </div>
  </div>
</template>

<script>
import filters from "../filters";
import utils from "./report-utils";
import ContactInfo from "./ContactInfo";

export default {
  name: "C4ScheduleCReceipts",
  components: {ContactInfo},
  props: {
    report: Object
  },
  data() {
    return {
      contacts: []
    }
  },
  methods: {
    ...filters.filters, ...utils
  },
  created() {
    this.contacts = this.report.user_data.contacts;
    this.sortByDate(this.report.user_data.contribution_corrections);
  }
}
</script>